import styled from 'styled-components';
import { Button, Typography } from 'antd';

const { Title } = Typography;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .page-wrapper-title {
    font-size: 16px;
  }
`;

export const PageHeader = styled.div`
  box-shadow: 0px 4px 20px 0px #e7eaf6;
  background-color: var(--white);
  padding: var(--padding-md) var(--padding-lg);
  z-index: 999;
`;

export const StyledTitle = styled(Title)`
  flex: 1;
  display: inline-flex;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  color: var(--text-color);
  height: auto;
  width: auto;
  line-height: 1;
  margin-right: 12px;
`;

export const PageContainer = styled.div<{
  $hidePaddings?: boolean;
  $color: string;
}>`
  flex: 1 0 auto;
  padding: ${({ $hidePaddings }) =>
    $hidePaddings ? '0px' : 'var(--padding-lg)'};
  ${({ $color }) => `background-color: var(--${$color})`}
`;
